import { AlgoliaBaseHit } from '@core/algolia';
import SearchIcon from '@img/icons/icon-search.svg';
import React, { FunctionComponent } from 'react';
import { ProductListHeaderStyles } from './ProductListHeader.styles';

export interface ProductListHeaderProps {
  title?: string | null;
  subTitle?: string | null;
  titleLogo?: string | null;
  description?: string | null;
  logoUrl?: string;
  inView: boolean;
  backText?: string | null;
  backUrl?: string | null;
  background: 'white' | 'grey';
  removeMaxWidth?: boolean;
  showReadMore?: boolean;
  readMoreText?: string | null;
  gridContainer?: boolean;
  textAlign?: 'center' | 'left';
  readMoreOnClick?: () => void;
  relatedSearchTerms?: AlgoliaBaseHit[];
  noPaddingBottom?: boolean;
}

const ProductListHeader: FunctionComponent<ProductListHeaderProps> = (props) => {
  const Inner = (
    <ProductListHeaderStyles.Header data-align={props.textAlign} data-nopadding-bottom={props.noPaddingBottom}>
      {props.backText && props.backUrl ? (
        <ProductListHeaderStyles.Back
          href={props.backUrl}
          dangerouslySetInnerHTML={{ __html: props.backText }}
        ></ProductListHeaderStyles.Back>
      ) : null}

      {props.logoUrl && props.logoUrl.length > 0 && (
        <ProductListHeaderStyles.Logo inView={props.inView}>
          <img src={props.logoUrl} alt={props.title || ''} loading="lazy" />
        </ProductListHeaderStyles.Logo>
      )}

      {props.title || props.description || props.subTitle ? (
        <>
          {props.title ? (
            <ProductListHeaderStyles.Title inView={props.inView}>
              {props.titleLogo ? <img src={props.titleLogo} alt={props.title} /> : null}
              <span dangerouslySetInnerHTML={{ __html: props.title }}></span>
            </ProductListHeaderStyles.Title>
          ) : null}
          {props.subTitle ? (
            <ProductListHeaderStyles.SubTitle inView={props.inView}>{props.subTitle}</ProductListHeaderStyles.SubTitle>
          ) : null}

          {props.relatedSearchTerms && props.relatedSearchTerms.length > 0 ? (
            <ProductListHeaderStyles.SearchTerms>
              {props.relatedSearchTerms.map((suggestion, index) => (
                <ProductListHeaderStyles.SearchTerm
                  key={index}
                  href={`${window.location.origin}${window.location.pathname}?searchTerm=${suggestion.query}`}
                >
                  <SearchIcon /> {suggestion.query}
                </ProductListHeaderStyles.SearchTerm>
              ))}
            </ProductListHeaderStyles.SearchTerms>
          ) : null}

          {props.description ? (
            <>
              <ProductListHeaderStyles.Content
                inView={props.inView}
                dangerouslySetInnerHTML={{ __html: props.description }}
              ></ProductListHeaderStyles.Content>
              {props.showReadMore && props.readMoreText && (
                <ProductListHeaderStyles.ReadMoreButton onClick={props.readMoreOnClick}>
                  {props.readMoreText}
                </ProductListHeaderStyles.ReadMoreButton>
              )}
            </>
          ) : null}
        </>
      ) : null}
    </ProductListHeaderStyles.Header>
  );

  if (props.gridContainer) {
    return (
      <ProductListHeaderStyles.Container background={props.background} removeMaxWidth={props.removeMaxWidth}>
        {Inner}
      </ProductListHeaderStyles.Container>
    );
  } else {
    return Inner;
  }
};

export default ProductListHeader;
